import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    realtime: {
      // iOS Safari may block wss:// synchronously in certain network/CSP conditions.
      // A long reconnect delay prevents rapid reconnect storms that surface WebSocket
      // errors through React's render lifecycle and trigger the ErrorBoundary.
      reconnectAfterMs: () => 30000,
    },
  },
);

export default supabase;
